import { GROUPS_FETCHED } from '../../actions/groups_actions';

export default function(state = null, action){
    switch (action.type){
        case GROUPS_FETCHED:
            let groups = action.payload;
            localStorage.setItem('groups', JSON.stringify(groups));
            return groups;
        default:
            break;
    }

    const data = localStorage.getItem('groups');
    if(data){
        return JSON.parse(data);
    }

    return null;
}


// WEBPACK FOOTER //
// ./src/reducers/groups/reducer_groups.js